import Rating from "./Rating";
import { getRate, getColor } from "./utils";

export default Rating;
export { getRate, getColor };
